import { cloneDeep, util, isCorrectVal } from 'utils';
//组件
import areaSelect from 'area-select';

export default {
    components: {
        'area-select': areaSelect
    },
    props: {
        value: {
            type: Boolean
        }
    },
    created () {
        this.result = cloneDeep(this.defaultData);
    },
    data () {
        return {
            visiable: false,
            defaultData: {
                Customer: '', //客户名称
                Tel: '', //客户电话
                C_Name: '', //主联系人
                Provinces_id: null, //省份ID
                City_id: null, //城市ID
                Area_id: null, //区县ID
                OldEmployee: '' //原属员工
            },
            result: null,
            areaInfo: {
                Provinces_Id: null,
                City_Id: null,
                Area_Id: null
            }
        };
    },
    watch: {
        value (val) {
            this.visiable = val;
        },
        visiable (val) {
            this.$emit('input', val);
        }
    },
    methods: {
        getFormdata () {
            this.result.Provinces_id = this.areaInfo.Provinces_Id;
            this.result.City_id = this.areaInfo.City_Id;
            this.result.Area_id = this.areaInfo.Area_Id;
            return this.result;
        },
        search () {
            let filterData = this.getFormdata();
            this.$emit('search', filterData);
        },
        reset () {
            this.result = cloneDeep(this.defaultData);
            this.areaInfo = cloneDeep(this.$refs.areaForm.defaultData);
            this.$emit('reset');
        }
    }
};


// WEBPACK FOOTER //
// ./src/pages/CRMagentPoor/components/complex-search/vm.js